import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_1M_44_1M_9_99',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_1m_44_1m_9_99_usd',
			EUR: 'simple_premium_1m_44_1m_9_99_eur',
			AUD: 'simple_premium_1m_72_1m_15_99_aud',
			CAD: 'simple_premium_1m_72_1m_15_99_cad',
			GBP: 'simple_premium_1m_44_1m_9_99_gbp',
			DKK: 'simple_premium_1m_379_1m_79_dkk',
			NOK: 'simple_premium_1m_579_1m_129_nok',
			SEK: 'simple_premium_1m_579_1m_129_sek',
			TRY: 'simple_premium_1m_1429_1m_325_try',
			BRL: 'simple_premium_1m_179_1w_34_brl',
			MXN: 'simple_premium_1m_729_1m_159_mxn',
			ARS: 'simple_premium_1m_58699_1m_13329_ars',
			COP: 'simple_premium_1m_175999_1m_39959_cop',
			CLP: 'simple_premium_1m_44000_1m_9990_clp',
		},
		primer: 'prd_sbY0NWq9GMkz',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'month',
		next_period_value: 1,
		next_period_type: 'month',
	},
	trial: {
		days: 30,
		priceMap: {
			USD: 9.99,
			EUR: 9.99,
			AUD: 15.99,
			CAD: 15.99,
			GBP: 9.99,
			DKK: 79,
			NOK: 129,
			SEK: 129,
			TRY: 325,
			BRL: 34,
			MXN: 159,
			ARS: 13329,
			COP: 39959,
			CLP: 9990,
		},
		originalPriceMap: {
			USD: 44,
			EUR: 44,
			AUD: 72,
			CAD: 72,
			GBP: 44,
			DKK: 379,
			NOK: 579,
			SEK: 579,
			TRY: 1429,
			BRL: 179,
			MXN: 729,
			ARS: 58699,
			COP: 175999,
			CLP: 44000,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 44,
			EUR: 44,
			AUD: 72,
			CAD: 72,
			GBP: 44,
			DKK: 379,
			NOK: 579,
			SEK: 579,
			TRY: 1429,
			BRL: 179,
			MXN: 729,
			ARS: 58699,
			COP: 175999,
			CLP: 44000,
		},
	},
}
